<h2 mat-dialog-title>
  {{ 'SHARE.TITLE' | translate }}
</h2>
<mat-dialog-content>
  <div class="dialog-content">
    @if (namespaceName$ | async; as namespaceName) {
      @if (changingPrivacyLevel) {
        <div class="stencil-shimmer"></div>
        <div class="stencil-shimmer"></div>
        <div class="stencil-shimmer"></div>
      } @else {
        <glxy-form-field>
          <glxy-label>{{ 'VISIBILITY.MEETING_VISIBILITY_V2' | translate }}</glxy-label>
          <mat-select [(ngModel)]="selectedPrivacyLevel" (selectionChange)="onPrivacyLevelChange($event.value)">
            <mat-option [value]="PrivacyLevel.PRIVACY_LEVEL_OPEN">
              {{ 'VISIBILITY.OPEN' | translate: { namespaceName: namespaceName } }}
            </mat-option>
            <mat-option [value]="PrivacyLevel.PRIVACY_LEVEL_UNLISTED">
              {{ 'VISIBILITY.UNLISTED_V2' | translate: { namespaceName: namespaceName } }}
            </mat-option>
            <mat-option [value]="PrivacyLevel.PRIVACY_LEVEL_PRIVATE">
              {{ 'VISIBILITY.PRIVATE' | translate }}
            </mat-option>
          </mat-select>
          <glxy-hint>@if (selectedPrivacyLevel === PrivacyLevel.PRIVACY_LEVEL_OPEN) {
            {{ 'VISIBILITY.VISIBILITY_DESCRIPTION.OPEN' | translate: { namespaceName: namespaceName } }}
          } @else if (selectedPrivacyLevel === PrivacyLevel.PRIVACY_LEVEL_UNLISTED) {
            {{ 'VISIBILITY.VISIBILITY_DESCRIPTION.UNLISTED' | translate: { namespaceName: namespaceName } }}
          } @else if (selectedPrivacyLevel === PrivacyLevel.PRIVACY_LEVEL_PRIVATE) {
            {{ 'VISIBILITY.VISIBILITY_DESCRIPTION.PRIVATE' | translate: { namespaceName: namespaceName } }}
          }</glxy-hint>
        </glxy-form-field>
      }
      <glxy-form-field bottomSpacing="none">
        <input
          matInput type="text"
          [value]="url"
          readonly
          tabIndex="-1"
          [disabled]="true"
        />
        <button class="suffix-button" mat-flat-button color="primary" (click)="copyLink()" matSuffix>
          <mat-icon>link</mat-icon>
          {{ 'COMMON.COPY_LINK' | translate }}
        </button>
      </glxy-form-field>
      <glxy-form-field>
        <mat-checkbox [(ngModel)]="atCurrentTime" tabIndex="-1">
          @if (currentTimestamp() < 1) {
            {{ 'SHARE.AT_BEGINNING' | translate }}
          } @else {
            {{ 'SHARE.AT_CURRENT_TIME' | translate }}
            @if (currentTimestamp() < hourInSeconds) {
              {{ currentTimestamp() | secondsToDateSeconds | date: 'mm:ss' }}
            } @else {
              {{ currentTimestamp() | secondsToDateSeconds | date: 'hh:mm:ss' }}
            }
          }
        </mat-checkbox>
      </glxy-form-field>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close tabIndex="-1">
    {{ 'COMMON.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
